/**
 * Convert different values to boolean
 * Default to `false` unless otherwise specified
 */
export function toBoolean(val: any, defaultValue = false) {
  const truthy = ['true', '1', 'y', 'yes']

  if (val && truthy.includes(val.toString().toLowerCase()))
    return true
  else
    return defaultValue
}
